module.exports = __webpack_public_path__ + "img/digitalizar.86f80f86.png";